<template>
    <!--
            作者：kmdshop
            时间：2019-10-25
            描述：营业数据
        -->
    <div class="user">

      <!--搜索表单-->
      <div class="common-seach-wrap">
        <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
          
            <!-- <el-form-item label="库区">
          <el-select size="small" v-model="formInline.warehouse_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in warehouse" :key="index" :label="item.name" :value="item.warehouse_id"></el-option>
          </el-select>
        </el-form-item>
         -->
        
            <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="formInline.create_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>

        <el-form-item label="产品名称"><el-input size="small" v-model="formInline.product_name" placeholder="请输入产品名称"></el-input></el-form-item>
          
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
  
      <!--内容-->
      <div class="product-content">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%"
           v-loading="loading" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="45"></el-table-column>
            <el-table-column type="id" prop="id" label="ID" ></el-table-column>
            <el-table-column prop="orderNumber" label="订单号"></el-table-column>
            <el-table-column prop="driver" label="司机"></el-table-column>
            <el-table-column prop="driverPhone" label="司机电话"></el-table-column>
            <el-table-column prop="storeCount" label="门店数量"></el-table-column>
            <el-table-column prop="route" label="路线"></el-table-column>
            <el-table-column prop="startingPoint" label="起点"></el-table-column>
            <el-table-column prop="destination" label="终点"></el-table-column>
            <el-table-column prop="endTime" label="截止时间"></el-table-column>
            <el-table-column prop="deliveryAmount" label="配送金额"></el-table-column>
            <el-table-column prop="orderStatus" label="订单状态"></el-table-column>


          </el-table>
        </div>
  
        <!--分页-->
        <div class="pagination">
          <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background :current-page="curPage"
          :page-sizes="[20, 100,500, 1000]"
          layout="total,sizes, prev, pager, next, jumper"
          :total="totalDataNumber"></el-pagination>
        </div>
      </div>
  
   
    </div>
  </template>
  
  <script>
    
  export default {
    components: {

    },
    data() {
      return {
        /*是否加载完成*/
        loading: false,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
           create_time: ''
        },
        warehouse:[]
       
      };
    },
    created() {
  
    },
  
    methods: {
       /*搜索查询*/
       onSubmit() {
        let self = this
        self.curPage = 1
  
      },
      handleSelectionChange(e) {
        this.multipleSelection = e;
      },
       /*选择第几页*/
       handleCurrentChange(val) {
        this.curPage = val
        this.getTableList()
      },
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1
        this.pageSize = val
        this.getTableList()
      },
      getTableList(){
  
      }
  
    }
  };
  </script>
  <style></style>
  


// WEBPACK FOOTER //
// src/views/report/driver.vue